import React from "react";
import "./SkeletonCard.scss";

function SkeletonCard({ count = 3, columns = 1 }) {
  return (
    <div className={`skeleton-cards-container skeleton-cards-container--cols-${columns}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-card__header">
            <div className="skeleton-line skeleton-line--title" />
            <div className="skeleton-line skeleton-line--badge" />
          </div>
          <div className="skeleton-card__body">
            <div className="skeleton-line skeleton-line--text skeleton-line--full" />
            <div className="skeleton-line skeleton-line--text skeleton-line--three-quarter" />
          </div>
          <div className="skeleton-card__meta">
            <div className="skeleton-line skeleton-line--meta" />
            <div className="skeleton-line skeleton-line--meta" />
            <div className="skeleton-line skeleton-line--meta" />
            <div className="skeleton-line skeleton-line--meta" />
          </div>
          <div className="skeleton-card__action">
            <div className="skeleton-line skeleton-line--link" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default SkeletonCard;
